import { TranslationMessages } from '../types';
import { app } from './app/pl';
import { settingsApp } from './app/pl';

const pl: TranslationMessages = {
  nav: {
    howItWorks: 'Jak to działa',
    why: 'Dlaczego?',
    features: 'Funkcje',
    getStarted: 'ROZPOCZNIJ',
    dashboard: 'Panel',
    blog: 'Blog',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Otrzymuj płatności łatwo',
    subtitle: 'Twórz linki płatności natychmiast, zarządzaj saldem i wypłacaj w TON. Opłata platformy 3%.',
    cta: 'Rozpocznij',
    hairsim: 'Symuluj przeszczep włosów',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Link płatności utworzony.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Subskrypcja miesięczna',
    stars: 'Stars',
    payBtn: 'Zapłać 100 Stars',
    iPayNow: 'Płacę teraz',
    paymentLabel: 'Płatność Telegram Stars',
    merchant: 'Sprzedawca',
    amount: 'Kwota',
    confirmPay: 'Potwierdź płatność',
    paymentReceived: 'Płatność otrzymana — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · zaksięgowano na saldo',
    thanks: 'Dziękujemy, dostęp aktywowany',
    messagePlaceholder: 'Wiadomość',
  },
  stats: {
    title: 'Zaufały nam tysiące agentów',
    subtitle: 'Dołącz do rosnącej społeczności sprzedawców korzystających z płatności Telegram Stars',
    activeAgents: 'Aktywni agenci',
    transactions: 'Transakcje',
    uptime: 'Dostępność',
    support: 'Wsparcie',
  },
  features: {
    title: 'Wszystko, czego potrzebujesz do akceptacji płatności Telegram Stars',
    subtitle: 'Kompletna platforma do zarządzania płatnościami Telegram Stars',
    instantTitle: 'Natychmiastowe tworzenie',
    instantDesc: 'Zostań agentem w kilka sekund. Bez konfiguracji.',
    balanceTitle: 'Zarządzanie saldem',
    balanceDesc: 'Śledź przychody w czasie rzeczywistym dzięki intuicyjnemu panelowi.',
    paymentsTitle: 'Płatności Telegram Stars',
    paymentsDesc: 'Akceptuj płatności w Telegram Stars przez swojego bota.',
    securityTitle: 'Maksymalne bezpieczeństwo',
    securityDesc: 'Niemutowalny rejestr, bezpieczne i przejrzyste transakcje.',
    withdrawTitle: 'Wypłaty TON',
    withdrawDesc: 'Wypłacaj środki bezpośrednio na swój adres TON.',
    apiTitle: 'Solidne API',
    apiDesc: 'Łatwa integracja z webhookami i pełnym REST API.',
  },
  how: {
    title: 'Jak to działa',
    subtitle: 'Zacznij w 3 prostych krokach',
    startDemo: 'Uruchom demo',
    demoRunning: 'Demo w toku...',
    reset: 'Resetuj',
    step1Title: '1. Zarejestruj się',
    email: 'Email',
    password: 'Hasło',
    noCard: '✓ Karta kredytowa nie jest wymagana',
    step2Title: '2. Twórz linki płatności',
    amountStars: 'Kwota (Stars)',
    generatedLink: 'Wygenerowany link:',
    shareLink: '✓ Udostępnij ten link klientom',
    step3Title: '3. Wypłać środki',
    tonAddress: 'Adres TON',
    availableBalance: 'Dostępne saldo:',
    fee: 'Opłata: 3%',
  },
  pricing: {
    title: 'Proste i przejrzyste ceny',
    subtitle: 'Bez ukrytych opłat, bez zobowiązań',
    commission: 'Prowizja',
    perTransaction: 'za transakcję',
    freeAccount: 'Bezpłatne utworzenie konta',
    noMonthly: 'Bez miesięcznych opłat',
    tonWithdrawals: 'Zintegrowane wypłaty TON',
    completeDashboard: 'Pełny panel',
    support247: 'Wsparcie 24/7',
    startNow: 'Rozpocznij teraz',
  },
  faq: {
    title: 'Często zadawane pytania',
    subtitle: 'Wszystko, co musisz wiedzieć o płatnościach Telegram Stars',
    q1: 'Jak działa płatność Telegram Stars?',
    a1: 'Płatność Telegram Stars umożliwia sprzedawcom akceptowanie płatności bezpośrednio przez Telegram. Użytkownicy tworzą linki płatności, udostępniają je klientom i otrzymują płatności w walucie Telegram Stars.',
    q2: 'Jaka jest opłata platformy?',
    a2: 'Opłata platformy wynosi 3% za transakcję. Obejmuje przetwarzanie płatności, zarządzanie rejestrem i utrzymanie platformy. Nie ma opłat za konfigurację ani miesięcznych kosztów.',
    q3: 'Jak wypłacić Telegram Stars?',
    a3: 'Możesz zlecić wypłatę na swój portfel TON. Wypłaty są przetwarzane ręcznie ze względów bezpieczeństwa. Minimalna wypłata to 100 Stars.',
    q4: 'Czy płatność Telegram Stars jest bezpieczna?',
    a4: 'Tak, wszystkie płatności są przetwarzane przez bezpieczny system płatności Telegram. Stosujemy standardowe szyfrowanie i praktyki bezpieczeństwa.',
    q5: 'Czym są Telegram Stars?',
    a5: 'Telegram Stars to wirtualna waluta używana w Telegram do płatności. Użytkownicy mogą kupować Stars i używać ich do opłacania usług, produktów i subskrypcji.',
    q6: 'Czy mogę używać płatności Telegram Stars w biznesie?',
    a6: 'Tak! Telegram Stars Payment Platform jest przeznaczona dla sprzedawców, twórców i firm. Możesz akceptować płatności za produkty cyfrowe, usługi, subskrypcje i więcej.',
  },
  cta: {
    title: 'Gotowy, aby zacząć?',
    subtitle: 'Dołącz do tysięcy agentów już korzystających z naszej platformy',
    createAccount: 'Utwórz darmowe konto',
    signIn: 'Zaloguj się',
  },
  footer: {
    description: 'Kompletna platforma SaaS do płatności Telegram Stars',
    product: 'Produkt',
    features: 'Funkcje',
    pricing: 'Cennik',
    support: 'Wsparcie',
    signIn: 'Zaloguj się',
    docs: 'Dokumentacja',
    copyright: '© 2024 Telegram Stars Payment Platform. Wszelkie prawa zastrzeżone.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Akceptuj płatności przez Telegram Stars',
    description: 'Akceptuj płatności przez Telegram Stars. Twórz linki płatności natychmiast, zarządzaj saldem i wypłacaj w TON. Opłata platformy 3%. Zacznij akceptować płatności Telegram Stars już dziś.',
    keywords: 'płatność telegram stars, akceptuj telegram stars, telegram stars payment platform, bramka płatności telegram stars',
  },
  whyPage: {
    seoTitle: 'Dlaczego Telegram Stars Payment Platform | Korzyści',
    seoDescription: 'Dowiedz się, dlaczego sprzedawcy i twórcy wybierają Telegram Stars Payment Platform: natychmiastowa konfiguracja, przejrzyste ceny, bezpieczne płatności i globalny zasięg.',
    title: 'Dlaczego my?',
    subtitle: 'Stworzone dla sprzedawców i twórców, którzy chcą prostych płatności Telegram Stars',
    r1Title: 'Natychmiastowa konfiguracja',
    r1Desc: 'Zacznij w kilka sekund. Bez skomplikowanej konfiguracji ani wiedzy technicznej.',
    r2Title: 'Przejrzyste ceny',
    r2Desc: 'Tylko 3% za transakcję. Bez ukrytych opłat, miesięcznych kosztów i opłat za konfigurację.',
    r3Title: 'Bezpieczne i niezawodne',
    r3Desc: 'Oparte na bezpiecznej infrastrukturze płatności Telegram ze standardowym szyfrowaniem.',
    r4Title: 'Globalny zasięg',
    r4Desc: 'Akceptuj płatności od użytkowników Telegram na całym świecie. Bez ograniczeń geograficznych.',
    r5Title: 'Łatwa integracja',
    r5Desc: 'Proste API i webhooki. Zintegruj się z istniejącymi systemami w kilka minut.',
    r6Title: 'Wypłaty TON',
    r6Desc: 'Wypłacaj bezpośrednio na swój portfel TON. Szybkie i bezpieczne wypłaty.',
  },
  howPage: {
    seoTitle: 'Jak to działa | Telegram Stars Payment Platform',
    seoDescription: 'Dowiedz się, jak akceptować płatności przez Telegram Stars w 3 prostych krokach. Utwórz konto, generuj linki płatności i wypłacaj w TON.',
    title: 'Jak to działa',
    subtitle: 'Akceptuj płatności Telegram Stars w trzech prostych krokach',
  },
  settings: {
    title: "Ustawienia",
    languageSection: "Język",
    defaultLanguage: "Domyślny język",
    languageHint: "Ten język obowiązuje w całej platformie (strony i interfejs).",
    languageSaved: "Język zaktualizowany",
    ...settingsApp,
  },
  app,
};

export default pl;
